/* Simple Vanilla JS Equal Heights */
(function() {
  function equalHeights(elements) {
    var maxHeight = 0;
    var items = Array.prototype.slice.call(elements);

    items.forEach(function(el) {
      el.style.height = '';
      var height = el.offsetHeight;
      if (height > maxHeight) maxHeight = height;
    });

    items.forEach(function(el) {
      el.style.height = maxHeight + 'px';
    });
  }

  function initEqualHeights() {
    document.querySelectorAll('[data-equal]').forEach(function(wrapper) {
      var selector = wrapper.getAttribute('data-equal');
      if (!selector) return;

      var elements = wrapper.querySelectorAll(selector);
      if (elements.length) {
        equalHeights(elements);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initEqualHeights);
  window.addEventListener('resize', function() {
    afterResize(initEqualHeights, 250, 'equal-heights');
  });
})();

/* Run function after window resize */
var afterResize = (function() {
  var t = {};

  return function(callback, ms, uniqueId) {
    uniqueId = uniqueId || "Don't call this twice without a uniqueId";

    if (t[uniqueId]) {
      clearTimeout(t[uniqueId]);
    }

    t[uniqueId] = setTimeout(callback, ms);
  };
})();

window.theme = window.theme || {};

/* ================ VENDOR ================ */
/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
!function(a,b,c){var d=window.matchMedia;"undefined"!=typeof module&&module.exports?module.exports=c(d):"function"==typeof define&&define.amd?define(function(){return b[a]=c(d)}):b[a]=c(d)}("enquire",this,function(a){"use strict";function b(a,b){var c,d=0,e=a.length;for(d;e>d&&(c=b(a[d],d),c!==!1);d++);}function c(a){return"[object Array]"===Object.prototype.toString.apply(a)}function d(a){return"function"==typeof a}function e(a){this.options=a,!a.deferSetup&&this.setup()}function f(b,c){this.query=b,this.isUnconditional=c,this.handlers=[],this.mql=a(b);var d=this;this.listener=function(a){d.mql=a,d.assess()},this.mql.addListener(this.listener)}function g(){if(!a)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!a("only all").matches}return e.prototype={setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(a){return this.options===a||this.options.match===a}},f.prototype={addHandler:function(a){var b=new e(a);this.handlers.push(b),this.matches()&&b.on()},removeHandler:function(a){var c=this.handlers;b(c,function(b,d){return b.equals(a)?(b.destroy(),!c.splice(d,1)):void 0})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){b(this.handlers,function(a){a.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var a=this.matches()?"on":"off";b(this.handlers,function(b){b[a]()})}},g.prototype={register:function(a,e,g){var h=this.queries,i=g&&this.browserIsIncapable;return h[a]||(h[a]=new f(a,i)),d(e)&&(e={match:e}),c(e)||(e=[e]),b(e,function(b){d(b)&&(b={match:b}),h[a].addHandler(b)}),this},unregister:function(a,b){var c=this.queries[a];return c&&(b?c.removeHandler(b):(c.clear(),delete this.queries[a])),this}},new g});
/* Modernizr 2.8.2 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-fontface-csstransforms-csstransforms3d-touch-cssclasses-teststyles-testprop-testallprops-prefixes-domprefixes-cssclassprefix:supports!
 */
;window.Modernizr=function(a,b,c){function z(a){j.cssText=a}function A(a,b){return z(m.join(a+";")+(b||""))}function B(a,b){return typeof a===b}function C(a,b){return!!~(""+a).indexOf(b)}function D(a,b){for(var d in a){var e=a[d];if(!C(e,"-")&&j[e]!==c)return b=="pfx"?e:!0}return!1}function E(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:B(f,"function")?f.bind(d||b):f}return!1}function F(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+o.join(d+" ")+d).split(" ");return B(b,"string")||B(b,"undefined")?D(e,b):(e=(a+" "+p.join(d+" ")+d).split(" "),E(e,b,c))}var d="2.8.2",e={},f=!0,g=b.documentElement,h="modernizr",i=b.createElement(h),j=i.style,k,l={}.toString,m=" -webkit- -moz- -o- -ms- ".split(" "),n="Webkit Moz O ms",o=n.split(" "),p=n.toLowerCase().split(" "),q={},r={},s={},t=[],u=t.slice,v,w=function(a,c,d,e){var f,i,j,k,l=b.createElement("div"),m=b.body,n=m||b.createElement("body");if(parseInt(d,10))while(d--)j=b.createElement("div"),j.id=e?e[d]:h+(d+1),l.appendChild(j);return f=["&#173;",'<style id="s',h,'">',a,"</style>"].join(""),l.id=h,(m?l:n).innerHTML+=f,n.appendChild(l),m||(n.style.background="",n.style.overflow="hidden",k=g.style.overflow,g.style.overflow="hidden",g.appendChild(n)),i=c(l,a),m?l.parentNode.removeChild(l):(n.parentNode.removeChild(n),g.style.overflow=k),!!i},x={}.hasOwnProperty,y;!B(x,"undefined")&&!B(x.call,"undefined")?y=function(a,b){return x.call(a,b)}:y=function(a,b){return b in a&&B(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=u.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(u.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(u.call(arguments)))};return e}),q.touch=function(){var c;return"ontouchstart"in a||a.DocumentTouch&&b instanceof DocumentTouch?c=!0:w(["@media (",m.join("touch-enabled),("),h,")","{#modernizr{top:9px;position:absolute}}"].join(""),function(a){c=a.offsetTop===9}),c},q.csstransforms=function(){return!!F("transform")},q.csstransforms3d=function(){var a=!!F("perspective");return a&&"webkitPerspective"in g.style&&w("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}",function(b,c){a=b.offsetLeft===9&&b.offsetHeight===3}),a},q.fontface=function(){var a;return w('@font-face {font-family:"font";src:url("https://")}',function(c,d){var e=b.getElementById("smodernizr"),f=e.sheet||e.styleSheet,g=f?f.cssRules&&f.cssRules[0]?f.cssRules[0].cssText:f.cssText||"":"";a=/src/i.test(g)&&g.indexOf(d.split(" ")[0])===0}),a};for(var G in q)y(q,G)&&(v=G.toLowerCase(),e[v]=q[G](),t.push((e[v]?"":"no-")+v));return e.addTest=function(a,b){if(typeof a=="object")for(var d in a)y(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof f!="undefined"&&f&&(g.className+=" supports-"+(b?"":"no-")+a),e[a]=b}return e},z(""),i=k=null,e._version=d,e._prefixes=m,e._domPrefixes=p,e._cssomPrefixes=o,e.testProp=function(a){return D([a])},e.testAllProps=F,e.testStyles=w,g.className=g.className.replace(/(^|\s)no-js(\s|$)/,"$1$2")+(f?" supports-js supports-"+t.join(" supports-"):""),e}(this,this.document);


/*================ TIMBER ================*/
window.timber = window.timber || {};

timber.cacheSelectors = function() {
  timber.cache = {
    html: document.documentElement,
    body: document.body,
    window: window,
  };
};

timber.init = function() {
  timber.cacheSelectors();
  timber.autoResponsiveElements();
};

timber.autoResponsiveElements = function() {
  var iframeVideos = Array.prototype.slice.call(
    document.querySelectorAll('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]')
  );

  var adminIframe = document.querySelector('iframe#admin_bar_iframe');
  var iframeReset = iframeVideos.slice();

  if (adminIframe) {
    iframeReset.push(adminIframe);
  }

  document.querySelectorAll('table').forEach(function(table) {
    if (table.parentElement && table.parentElement.classList.contains('table-wrapper')) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'table-wrapper';

    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });

  iframeVideos.forEach(function(iframe) {
    if (iframe.closest('.video-wrapper')) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'video-wrapper';

    iframe.parentNode.insertBefore(wrapper, iframe);
    wrapper.appendChild(iframe);
  });
};

// Initialize Timber's JS on docready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', timber.init);
} else {
  timber.init();
}


/* ================ SLATE ================ */
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
  document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
  document.addEventListener('shopify:section:select', this._onSelect.bind(this));
  document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
  document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
  document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    if (!container) return;

    var id = container.getAttribute('data-section-id');
    var type = container.getAttribute('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = evt.target.querySelector('[data-section-id]');

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = this.instances.filter(function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance && typeof instance.onUnload === 'function') {
        instance.onUnload(evt);
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function(container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});


/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 */

theme.a11y = {
  _focusTrapHandlers: {},

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just element.focus();
   *
   * @param {Element|NodeList|Array<Element>} element - The element to be acted upon
   */
  pageLinkFocus: function(element) {
    var focusClass = 'js-focus-hidden';
    var target = element instanceof Element ? element : element && element[0];

    if (!target) return;

    target.setAttribute('tabindex', '-1');
    target.focus();
    target.classList.add(focusClass);

    function callback() {
      target.classList.remove(focusClass);
      target.removeAttribute('tabindex');
      target.removeEventListener('blur', callback);
    }

    target.addEventListener('blur', callback, { once: true });
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus(document.querySelector(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    document.querySelectorAll('a[href*="#"]').forEach(
      function(link) {
        link.addEventListener(
          'click',
          function(evt) {
            if (!evt.currentTarget.hash) return;

            var target = document.querySelector(evt.currentTarget.hash);
            if (target) {
              this.pageLinkFocus(target);
            }
          }.bind(this)
        );
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {Element} options.container - Container to trap focus within
   * @param {Element} options.elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var namespace = options.namespace || 'default';
    var container = options.container;
    var elementToFocus = options.elementToFocus || container;

    if (!container) return;

    if (this._focusTrapHandlers[namespace]) {
      document.removeEventListener('focusin', this._focusTrapHandlers[namespace]);
    }

    container.setAttribute('tabindex', '-1');

    if (elementToFocus) {
      elementToFocus.focus();
    }

    var handler = function(evt) {
      if (container !== evt.target && !container.contains(evt.target)) {
        container.focus();
      }
    };

    this._focusTrapHandlers[namespace] = handler;
    document.addEventListener('focusin', handler);
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {Element} options.container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var namespace = (options && options.namespace) || 'default';
    var container = options && options.container;
    var handler = this._focusTrapHandlers[namespace];

    if (container) {
      container.removeAttribute('tabindex');
    }

    if (handler) {
      document.removeEventListener('focusin', handler);
      delete this._focusTrapHandlers[namespace];
    }
  }
};

window.Shopify = window.Shopify || {};

Shopify.formatMoney = Shopify.formatMoney || function(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var moneyFormat = format || '{{ amount }}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;

    if (isNaN(number) || number == null) {
      return '0';
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + thousands
    );
    var centsPart = parts[1] ? decimal + parts[1] : '';

    return dollars + centsPart;
  }

  var match = moneyFormat.match(placeholderRegex);
  if (!match) return moneyFormat;

  switch (match[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
  }

  return moneyFormat.replace(placeholderRegex, value);
};

/*================ SECTIONS ================*/
theme.Product = (function() {
  function mkGetSelectedOptions(form) {
    var values = [];

    var swatches = form.querySelectorAll('.swatch');

    swatches.forEach(function(swatch) {
      var checked = swatch.querySelector('input[type="radio"]:checked');
      if (checked) {
        values.push(checked.value);
      }
    });

    return values;
  }

  function mkFindVariantByOptions(product, options) {
    if (!product || !product.variants) return null;

    return product.variants.find(function(variant) {
      return variant.options.every(function(opt, i) {
        return opt === options[i];
      });
    });
  }

  function mkApplyVariant(productInstance, variant) {
    if (!variant) return;

    var select = productInstance.container.querySelector('.product-single__variants');
    if (select) {
      select.value = variant.id;
    }

    var form = productInstance.container.querySelector('form');

    if (form && variant.options && variant.options.length) {
      variant.options.forEach(function(optionValue, optionIndex) {
        var swatchGroup = form.querySelector(
          '.swatch[data-option-index="' + optionIndex + '"]'
        );

        if (!swatchGroup) return;

        swatchGroup.querySelectorAll('input[type="radio"]').forEach(function(radio) {
          radio.checked = radio.value === optionValue;
        });
      });
    }

    productInstance.productPage({
      money_format: theme.moneyFormat,
      variant: variant,
      translations: {
        add_to_cart: theme.strings.addToCart,
        sold_out: theme.strings.soldOut,
        unavailable: theme.strings.unavailable
      }
    });

    if (productInstance.enableHistoryState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    document.dispatchEvent(new CustomEvent('mk:variant:change', {
      detail: { variant: variant }
    }));
  }

  function Product(container) {
    this.container = container;
    if (!this.container) return;

    this.sectionId = this.container.getAttribute('data-section-id');

    this.selectors = {
      html: document.documentElement,
      addToCart: this.container.querySelector('#AddToCart'),
      productPrice: this.container.querySelector('#ProductPrice'),
      comparePrice: this.container.querySelector('#ComparePrice'),
      comparePriceA11y: this.container.querySelector('#ComparePriceA11y'),
      priceA11y: this.container.querySelector('#PriceA11y'),
      quantityElements: Array.prototype.slice.call(
        this.container.querySelectorAll('.product-single__quantity')
      ),
      addToCartText: this.container.querySelector('#AddToCartText'),
      tabTrigger: Array.prototype.slice.call(
        this.container.querySelectorAll('.tab-switch__trigger')
      ),
      tabContent: Array.prototype.slice.call(
        this.container.querySelectorAll('.tab-switch__content')
      ),
      productFullDetails: this.container.querySelector('.product-single__full-details'),
      SKU: this.container.querySelector('.variant-sku'),
      shopifyPaymentButton: this.container.querySelector('.shopify-payment-button'),
      unitPrice: this.container.querySelector('[data-unit-price]'),
      unitPriceBaseUnit: this.container.querySelector('[data-unit-price-base-unit]'),
      unitPriceContainer: this.container.querySelector('[data-unit-price-container]')
    };

    this.classes = {
      hide: 'hide'
    };

    var productJson = document.getElementById('ProductJson-' + this.sectionId);

    if (!productJson || !productJson.innerHTML) {
      return;
    }

    this.showExtraTab = this.container.getAttribute('data-show-extra-tab') === 'true';
    this.extraTabContent = this.container.getAttribute('data-extra-tab-content') || '';
    this.enableHistoryState =
      this.container.getAttribute('data-enable-history-state') === 'true';

    this.productSingleObject = JSON.parse(productJson.innerHTML);
    this.init();
  }

  Product.prototype = Object.assign({}, Product.prototype, {
    init: function() {
      this.initCustomVariantLogic();

      // 👉 NEU: Initiale Variante setzen
      var initialVariantId = null;
      var urlParams = new URLSearchParams(window.location.search);

      if (urlParams.has('variant')) {
        initialVariantId = parseInt(urlParams.get('variant'), 10);
      }

      var initialVariant = null;

      if (initialVariantId) {
        initialVariant = this.productSingleObject.variants.find(function(v) {
          return v.id === initialVariantId;
        });
      }

      // fallback: erste verfügbare Variante
      if (!initialVariant) {
        initialVariant = this.productSingleObject.variants.find(function(v) {
          return v.available;
        }) || this.productSingleObject.variants[0];
      }

      if (initialVariant) {
        mkApplyVariant(this, initialVariant);
      }

      if (!this.showExtraTab || this.extraTabContent) {
        this.initProductTabs();
      }
    },

    initProductTabs: function() {
      if (!this.selectors.tabTrigger.length) {
        return;
      }

      var triggers = this.selectors.tabTrigger;
      var contents = this.selectors.tabContent;

      contents.forEach(function(content, index) {
        if (index > 0) {
          content.classList.add('is-hidden');
        }
      });

      triggers[0].classList.add('is-active');

      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function(evt) {
          evt.preventDefault();

          triggers.forEach(function(item) {
            item.classList.remove('is-active');
          });

          trigger.classList.add('is-active');

          var link = trigger.getAttribute('data-link');

          contents.forEach(function(content) {
            content.classList.add('is-hidden');

            if (content.getAttribute('data-content') === link) {
              content.classList.remove('is-hidden');
            }
          });
        });
      });
    },

    initCustomVariantLogic: function() {
      var self = this;
      var form = this.container.querySelector('form');

      if (!form) return;

      var swatches = form.querySelectorAll('.swatch input[type="radio"]');

      // 🔹 Swatch → Variant
      swatches.forEach(function(radio) {
        radio.addEventListener('change', function() {
          var options = mkGetSelectedOptions(form);
          var variant = mkFindVariantByOptions(self.productSingleObject, options);

          mkApplyVariant(self, variant);
        });
      });

      document.addEventListener('mk:gallery:variant:select', function(e) {
        var variant = e.detail && e.detail.variant;
        if (!variant) return;

        mkApplyVariant(self, variant);

        if (variant.options && variant.options.length) {
          variant.options.forEach(function(optionValue, optionIndex) {
            var swatchGroup = form.querySelector(
              '.swatch[data-option-index="' + optionIndex + '"]'
            );

            if (!swatchGroup) return;

            swatchGroup.querySelectorAll('input[type="radio"]').forEach(function(radio) {
              radio.checked = radio.value === optionValue;
            });
          });
        }
      });
    },

    productPage: function(options) {
      var moneyFormat = options.money_format;
      var variant = options.variant;
      var translations = options.translations;

      if (variant) {

        if (variant.available) {
          if (this.selectors.addToCart) {
            this.selectors.addToCart.classList.remove('disabled');
            this.selectors.addToCart.classList.add('btn-warenkorb-active');
            this.selectors.addToCart.disabled = false;
            this.selectors.addToCart.removeAttribute('aria-disabled');
          }

          if (this.selectors.addToCartText) {
            this.selectors.addToCartText.innerHTML = translations.add_to_cart;
          }

          this.selectors.quantityElements.forEach(function(element) {
            element.style.display = '';
          });

          if (this.selectors.shopifyPaymentButton) {
            this.selectors.shopifyPaymentButton.style.display = '';
          }

          if (this.selectors.productFullDetails) {
            this.selectors.productFullDetails.setAttribute(
              'href',
              this.updateUrlParameter(
                this.selectors.productFullDetails.getAttribute('href'),
                'variant',
                variant.id
              )
            );
          }
        } else {
          if (this.selectors.addToCart) {
            this.selectors.addToCart.classList.add('disabled');
            this.selectors.addToCart.classList.remove('btn-warenkorb-active');
            this.selectors.addToCart.disabled = true;
            this.selectors.addToCart.setAttribute('aria-disabled', 'true');
          }

          if (this.selectors.addToCartText) {
            this.selectors.addToCartText.innerHTML = translations.sold_out;
          }

          this.selectors.quantityElements.forEach(function(element) {
            element.style.display = 'none';
          });

          if (this.selectors.shopifyPaymentButton) {
            this.selectors.shopifyPaymentButton.style.display = 'none';
          }
        }

        if (this.selectors.productPrice) {
          this.selectors.productPrice.innerHTML = Shopify.formatMoney(
            variant.price,
            moneyFormat
          );
        }

        if (this.selectors.SKU) {
          this.selectors.SKU.innerHTML = variant.sku;
        }

        if (variant.compare_at_price > variant.price) {
          if (this.selectors.comparePrice) {
            this.selectors.comparePrice.innerHTML = Shopify.formatMoney(
              variant.compare_at_price,
              moneyFormat
            );
            this.selectors.comparePrice.classList.remove(this.classes.hide);
          }

          if (this.selectors.comparePriceA11y) {
            this.selectors.comparePriceA11y.setAttribute('aria-hidden', 'false');
          }

          if (this.selectors.priceA11y) {
            this.selectors.priceA11y.setAttribute('aria-hidden', 'false');
          }
        } else {
          if (this.selectors.comparePrice) {
            this.selectors.comparePrice.classList.add(this.classes.hide);
            this.selectors.comparePrice.innerHTML = '';
          }

          if (this.selectors.comparePriceA11y) {
            this.selectors.comparePriceA11y.setAttribute('aria-hidden', 'true');
          }
        }

        if (this.selectors.unitPriceContainer) {
          this.selectors.unitPriceContainer.classList.add(this.classes.hide);
        }

        if (variant.unit_price) {
          if (this.selectors.unitPrice) {
            this.selectors.unitPrice.innerHTML = Shopify.formatMoney(
              variant.unit_price,
              theme.moneyFormat
            );
          }

          if (this.selectors.unitPriceBaseUnit) {
            this.selectors.unitPriceBaseUnit.innerHTML = this.getBaseUnit(variant);
          }

          if (this.selectors.unitPriceContainer) {
            this.selectors.unitPriceContainer.classList.remove(this.classes.hide);
          }
        }
      } else {
        if (this.selectors.addToCart) {
          this.selectors.addToCart.classList.add('disabled');
          this.selectors.addToCart.disabled = true;
        }

        if (this.selectors.addToCartText) {
          this.selectors.addToCartText.innerHTML = translations.unavailable;
        }

        this.selectors.quantityElements.forEach(function(element) {
          element.style.display = 'none';
        });

        if (this.selectors.shopifyPaymentButton) {
          this.selectors.shopifyPaymentButton.style.display = 'none';
        }
      }
    },

    updateUrlParameter: function(url, key, value) {
      if (!url) return url;

      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
      var separator = url.indexOf('?') === -1 ? '?' : '&';

      if (url.match(re)) {
        return url.replace(re, '$1' + key + '=' + value + '$2');
      }

      return url + separator + key + '=' + value;
    },

    getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  });

  return Product;
})();

theme.Collection = (function() {
  function Collection(container) {
    this.container = container;
    if (!this.container) return;

    this.selectors = {
      productGridImages: '.grid-link__image--product'
    };

    this.sortEnabled = this.container.getAttribute('data-sort-enabled') === 'true';
    this.tagsEnabled = this.container.getAttribute('data-tags-enabled') === 'true';

    this.productGridImages = Array.prototype.slice.call(
      this.container.querySelectorAll(this.selectors.productGridImages)
    );

    this.init();
  }

  Collection.prototype = Object.assign({}, Collection.prototype, {
    init: function() {
      this.stringOverrides();
      theme.cacheSelectors();
      theme.equalHeights(this.productGridImages);

      if (this.sortEnabled) {
        this.collectionSorting();
      }

      if (this.tagsEnabled) {
        this.collectionTags();
      }
    },

    stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      theme.strings = theme.strings || {};

      Object.assign(theme.strings, theme.productStrings);
    },

    collectionSorting: function() {
      Shopify.queryParams = {};

      if (location.search.length && location.search.indexOf('sort_by') !== -1) {
        var queryPairs = location.search.substr(1).split('&');

        queryPairs.forEach(function(pair) {
          var keyValue = pair.split('=');

          if (keyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(keyValue[0])] =
              decodeURIComponent(keyValue[1]);
          }
        });
      }

      var sortBy = document.getElementById('SortBy');
      if (!sortBy) return;

      sortBy.value = theme.strings.sortBy;

      sortBy.addEventListener('change', function() {
        Shopify.queryParams.sort_by = sortBy.value;
        location.search = new URLSearchParams(Shopify.queryParams).toString();
      });
    },

    collectionTags: function() {
      var browseBy = document.getElementById('BrowseBy');
      if (!browseBy) return;

      browseBy.addEventListener('change', function() {
        location.href = browseBy.value;
      });
    }
  });

  return Collection;
})();

theme.ListCollections = (function() {
  function ListCollections(container) {
    this.container = container;
    if (!this.container) return;

    this.selectors = {
      collectionGridImages: '.grid-link__image--collection'
    };

    this.collectionGridImages = Array.prototype.slice.call(
      this.container.querySelectorAll(this.selectors.collectionGridImages)
    );

    this.init();
  }

  ListCollections.prototype = Object.assign({}, ListCollections.prototype, {
    init: function() {
      theme.cacheSelectors();
      theme.equalHeights(this.collectionGridImages);
    }
  });

  return ListCollections;
})();

theme.Cart = (function() {
  var selectors = {
    body: 'body',
    cartSection: '#CartSection',
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart() {
    var cartSection = document.querySelector(selectors.cartSection);

    if (!cartSection) return;

    if (!cookiesEnabled()) {
      cartSection.classList.add(selectors.cartNoCookies);
    }

    if (cartSection.getAttribute('data-notes-enable') !== 'true') {
      return;
    }
  }

  function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }

    return cookieEnabled;
  }

  return Cart;
})();

theme.Header = (function() {
  function Header() {
    this.selectors = {
      headerBar: '.header-bar',
      mobileNavTrigger: '#MobileNavTrigger',
      mobileNav: '#MobileNav',
      mobileSublistTrigger: '.mobile-nav__sublist-trigger',
      showDropdownClass: 'show-dropdown',
      hasDropdownItem: '.site-nav--has-dropdown',
      body: 'body'
    };

    this.init();
  }

  Header.prototype = Object.assign({}, Header.prototype, {
    init: function() {
      var self = this;

      this.cacheSelectors();

      if (cache.mobileNavTrigger) {
        cache.mobileNavTrigger.addEventListener('click', this._mobileNavTriggerHandler = function(evt) {
          evt.preventDefault();

          var isExpanded = cache.mobileNavTrigger.getAttribute('aria-expanded');

          if (isExpanded === 'true') {
            self.menuClose();
          } else {
            self.menuOpen();
          }
        });
      }

      cache.mobileSublistTrigger.forEach(function(trigger) {
        trigger.addEventListener('click', function(evt) {
          var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
          var sublist = trigger.nextElementSibling;

          evt.preventDefault();

          trigger.classList.toggle('is-active');
          trigger.setAttribute('aria-expanded', String(!isExpanded));

          if (sublist && sublist.classList.contains('mobile-nav__sublist')) {
            slideToggle(sublist, 200);
          }

          if (
            !trigger.classList.contains(self.selectors.showDropdownClass) &&
            timber.vars &&
            timber.vars.isTouch
          ) {
            trigger.classList.add(self.selectors.showDropdownClass);

            document.addEventListener('click', function handleClickOutsideDropdown(evt) {
              if (evt.target !== trigger && !trigger.contains(evt.target)) {
                trigger.classList.remove(self.selectors.showDropdownClass);
                document.removeEventListener('click', handleClickOutsideDropdown);
              }
            });
          }
        });
      });
    },

    cacheSelectors: function() {
      window.cache = window.cache || {};

      Object.assign(window.cache, {
        doc: document,
        headerBar: document.querySelector(this.selectors.headerBar),
        mobileNavTrigger: document.querySelector(this.selectors.mobileNavTrigger),
        mobileNav: document.querySelector(this.selectors.mobileNav),
        mobileSublistTrigger: Array.prototype.slice.call(
          document.querySelectorAll(this.selectors.mobileSublistTrigger)
        ),
        hasDropdownItem: Array.prototype.slice.call(
          document.querySelectorAll(this.selectors.hasDropdownItem)
        )
      });
    },

    onUnload: function() {
      if (cache.mobileNavTrigger && this._mobileNavTriggerHandler) {
        cache.mobileNavTrigger.removeEventListener('click', this._mobileNavTriggerHandler);
      }
    },

    menuOpen: function() {
      var self = this;

      if (!cache.mobileNavTrigger || !cache.mobileNav || !cache.headerBar) return;

      cache.mobileNavTrigger.setAttribute('aria-expanded', 'true');
      slideDown(cache.mobileNav, 220);

      var firstLink = cache.mobileNav.querySelector('> li:first-child a');

      theme.a11y.trapFocus({
        container: cache.headerBar,
        elementToFocus: firstLink || cache.mobileNav,
        namespace: 'drawerMenu'
      });

      this._drawerKeyupHandler = function(evt) {
        if (evt.keyCode === 27) {
          self.menuClose();
        }
      };

      this._drawerMouseDownHandler = function(evt) {
        if (!cache.headerBar.contains(evt.target)) {
          self.menuClose();
        }
      };

      document.documentElement.addEventListener('keyup', this._drawerKeyupHandler);
      document.addEventListener('mousedown', this._drawerMouseDownHandler);
    },

    menuClose: function() {
      if (!cache.mobileNavTrigger || !cache.mobileNav || !cache.headerBar) return;

      cache.mobileNavTrigger.setAttribute('aria-expanded', 'false');
      slideUp(cache.mobileNav, 220);

      if (this._drawerKeyupHandler) {
        document.documentElement.removeEventListener('keyup', this._drawerKeyupHandler);
        this._drawerKeyupHandler = null;
      }

      if (this._drawerMouseDownHandler) {
        document.removeEventListener('mousedown', this._drawerMouseDownHandler);
        this._drawerMouseDownHandler = null;
      }

      theme.a11y.removeTrapFocus({
        container: cache.headerBar,
        namespace: 'drawerMenu'
      });
    }
  });

  function slideDown(element, duration) {
    if (!element) return;

    element.style.removeProperty('display');
    var display = window.getComputedStyle(element).display;

    if (display === 'none') {
      display = 'block';
    }

    element.style.display = display;

    var height = element.scrollHeight;

    element.style.overflow = 'hidden';
    element.style.height = '0';
    element.style.transitionProperty = 'height';
    element.style.transitionDuration = duration + 'ms';

    window.requestAnimationFrame(function() {
      element.style.height = height + 'px';
    });

    window.setTimeout(function() {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition-property');
      element.style.removeProperty('transition-duration');
    }, duration);
  }

  function slideUp(element, duration) {
    if (!element) return;

    element.style.height = element.scrollHeight + 'px';
    element.style.overflow = 'hidden';
    element.style.transitionProperty = 'height';
    element.style.transitionDuration = duration + 'ms';

    window.requestAnimationFrame(function() {
      element.style.height = '0';
    });

    window.setTimeout(function() {
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition-property');
      element.style.removeProperty('transition-duration');
    }, duration);
  }

  function slideToggle(element, duration) {
    if (!element) return;

    if (window.getComputedStyle(element).display === 'none') {
      slideDown(element, duration);
    } else {
      slideUp(element, duration);
    }
  }

  return Header;
})();

theme.CollectionList = (function() {
  function CollectionList(container) {
    this.container = container;

    this.selectors = {
      collectionGridImages: '.grid-link__image--collection'
    };

    this.collectionGridImages = Array.from(
      this.container.querySelectorAll(this.selectors.collectionGridImages)
    );

    this.init();
  }

  CollectionList.prototype = Object.assign({}, CollectionList.prototype, {
    init: function() {
      theme.cacheSelectors();
      theme.equalHeights(this.collectionGridImages);
    }
  });

  return CollectionList;
})();

theme.FeaturedProducts = (function() {
  function FeaturedProducts(container) {
    this.container = container;

    this.selectors = {
      productGridImages: '.grid-link__image--product'
    };

    this.productGridImages = Array.from(
      this.container.querySelectorAll(this.selectors.productGridImages)
    );

    this.init();
  }

  FeaturedProducts.prototype = Object.assign({}, FeaturedProducts.prototype, {
    init: function() {
      theme.cacheSelectors();
      theme.equalHeights(this.productGridImages);
    }
  });

  return FeaturedProducts;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  function Map(container) {
    window.theme.$currentMapContainer = this.container = container;
    this.map = null;
    this.center = null;
    this._resizeHandler = null;

    var key = this.container.dataset.apiKey;

    if (typeof key !== 'string' || key === '') {
      return;
    }

    if (apiStatus === 'loaded') {
      var existingScript = document.querySelector('script[src*="' + key + '&"]');

      if (!existingScript) {
        loadScript('https://maps.googleapis.com/maps/api/js?key=' + key).then(
          function() {
            apiStatus = 'loaded';
            this.createMap();
          }.bind(this)
        );
      } else {
        this.createMap();
      }
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';

        if (typeof window.google === 'undefined') {
          loadScript('https://maps.googleapis.com/maps/api/js?key=' + key).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function loadScript(src) {
    return new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function initAllMaps() {
    mapsToLoad.forEach(function(instance) {
      instance.createMap();
    });
  }

  function geolocate(mapElement) {
    return new Promise(function(resolve, reject) {
      var geocoder = new google.maps.Geocoder();
      var address = mapElement.dataset.addressSetting;

      geocoder.geocode({ address: address }, function(results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          reject(status);
          return;
        }

        resolve(results);
      });
    });
  }

  Map.prototype = Object.assign({}, Map.prototype, {
    createMap: function() {
      var mapElement = this.container.querySelector('.map-section__container');
      var self = this;

      if (!mapElement) return Promise.resolve();

      return geolocate(mapElement)
        .then(function(results) {
          var mapOptions = {
            zoom: config.zoom,
            styles: config.styles,
            center: results[0].geometry.location,
            draggable: false,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true
          };

          var map = (self.map = new google.maps.Map(mapElement, mapOptions));
          var center = (self.center = map.getCenter());

          new google.maps.Marker({
            map: map,
            position: center
          });

          self._resizeHandler = function() {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
          };

          window.addEventListener('resize', self._resizeHandler);
        })
        .catch(function(status) {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          if (Shopify.designMode) {
            var mapContainer = mapElement.closest('.map-section');

            if (mapContainer) {
              mapContainer.classList.add('page-width', 'map-section--load-error');

              var wrapper = mapContainer.querySelector('.map-section__wrapper');
              if (wrapper) {
                wrapper.innerHTML =
                  '<div class="errors text-center">' + errorMessage + '</div>';
              }
            }
          }
        });
    },

    onUnload: function() {
      if (this._resizeHandler) {
        window.removeEventListener('resize', this._resizeHandler);
        this._resizeHandler = null;
      }
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  if (!Shopify.designMode) return;
  if (!theme.currentMapContainer) return;

  theme.currentMapContainer.classList.add('page-width', 'map-section--load-error');

  var wrapper = theme.currentMapContainer.querySelector('.map-section__wrapper');

  if (wrapper) {
    wrapper.innerHTML =
      '<div class="errors text-center">' + theme.strings.authError + '</div>';
  }
}

window.theme = window.theme || {};

theme.PasswordHeader = (function() {
  function PasswordHeader() {
    this.init();
  }

  PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
    init: function() {
      var triggers = Array.prototype.slice.call(
        document.querySelectorAll('.js-toggle-login-modal')
      );

      var modal = document.querySelector('#LoginModal, .login-modal, .mfp-hide');

      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function(evt) {
          evt.preventDefault();

          if (modal) {
            modal.classList.remove('mfp-hide');
            modal.classList.add('password-modal-is-open');
            document.documentElement.classList.add('password-modal-open');

            window.setTimeout(function() {
              var passwordInput = document.getElementById('password');
              if (passwordInput) {
                passwordInput.focus();
              }
            }, 50);
          }
        });
      });

      if (document.querySelector('.storefront-password-form .errors')) {
        var firstTrigger = document.querySelector('.js-toggle-login-modal');

        if (firstTrigger) {
          firstTrigger.click();
        }
      }
    }
  });

  return PasswordHeader;
})();

theme.ProductRecommendations = (function() {
  var selectors = {
    productGridImages: '[data-image-wrapper]'
  };

  function ProductRecommendations(container) {
    this.container = container;
    if (!this.container) return;

    var baseUrl = this.container.getAttribute('data-base-url');
    var productId = this.container.getAttribute('data-product-id');

    if (!baseUrl || !productId) return;

    var recommendationsSectionUrl =
      baseUrl +
      '?section_id=product-recommendations&product_id=' +
      productId +
      '&limit=4';

    fetch(recommendationsSectionUrl)
      .then(function(response) {
        return response.text();
      })
      .then(
        function(section) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(section, 'text/html');
          var recommendationsMarkup = doc.body.innerHTML;

          if (recommendationsMarkup.trim() !== '') {
            this.container.innerHTML = recommendationsMarkup;

            theme.equalHeights(
              Array.prototype.slice.call(
                this.container.querySelectorAll(selectors.productGridImages)
              )
            );
          }
        }.bind(this)
      );
  }

  return ProductRecommendations;
})();

document.addEventListener('DOMContentLoaded', function() {
  var sections = new theme.Sections();

  sections.register('product-template', theme.Product);
  sections.register('collection-template', theme.Collection);
  sections.register('list-collections-template', theme.ListCollections);
  sections.register('cart-template', theme.Cart);
  sections.register('article-template', theme.Article);
  sections.register('header-section', theme.Header);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('collection-list-section', theme.CollectionList);
  sections.register('featured-products-section', theme.FeaturedProducts);
  sections.register('map-section', theme.Maps);
  sections.register('password-header', theme.PasswordHeader);
  sections.register('product-recommendations', theme.ProductRecommendations);
});

theme.cacheSelectors = function() {
  theme.cache = {
    w: window,
    html: document.documentElement
  };
};

timber.cacheVariables = function() {
  timber.vars = {
    isTouch: timber.cache.html.classList.contains('supports-touch')
  };
};

theme.init = function() {
  theme.cacheSelectors();
  timber.cacheVariables();
  theme.productCardImageLoadingAnimation();
};

theme.productCardImageLoadingAnimation = function() {
  var selectors = {
    image: '[data-image]',
    imageWrapper: '[data-image-wrapper]'
  };

  var classes = {
    loadingAnimation: 'grid-link__image--loading',
    lazyloaded: 'lazyloaded'
  };

  document.addEventListener('lazyloaded', function(e) {
    var target = e.target;

    if (!target.matches(selectors.image)) {
      return;
    }

    var wrapper = target.closest(selectors.imageWrapper);

    if (wrapper) {
      wrapper.classList.remove(classes.loadingAnimation);
    }
  });

  document.querySelectorAll(selectors.image + '.' + classes.lazyloaded).forEach(function(image) {
    var wrapper = image.closest(selectors.imageWrapper);

    if (wrapper) {
      wrapper.classList.remove(classes.loadingAnimation);
    }
  });
};

theme.equalHeights = function(elements) {
  elements = Array.prototype.slice.call(elements || []);

  if (!elements.length) return;

  window.addEventListener('load', function() {
    resizeElements(elements);
  });

  window.addEventListener('resize', function() {
    afterResize(function() {
      resizeElements(elements);
    }, 250, 'equal-heights');
  });

  resizeElements(elements);

  function resizeElements(elements) {
    imagesLoadedVanilla(elements, function() {
      var maxHeight = 0;

      elements.forEach(function(element) {
        element.style.height = 'auto';

        if (element.offsetHeight > maxHeight) {
          maxHeight = element.offsetHeight;
        }
      });

      elements.forEach(function(element) {
        element.style.height = maxHeight + 'px';
      });
    });
  }
};

function imagesLoadedVanilla(elements, callback) {
  var images = [];

  elements.forEach(function(element) {
    if (element.tagName === 'IMG') {
      images.push(element);
    }

    element.querySelectorAll('img').forEach(function(img) {
      images.push(img);
    });
  });

  if (!images.length) {
    callback();
    return;
  }

  var loaded = 0;

  function imageDone() {
    loaded++;

    if (loaded >= images.length) {
      callback();
    }
  }

  images.forEach(function(img) {
    if (img.complete) {
      imageDone();
    } else {
      img.addEventListener('load', imageDone, { once: true });
      img.addEventListener('error', imageDone, { once: true });
    }
  });
}

// Initialize theme's JS on docready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', theme.init);
} else {
  theme.init();
}

//______________________________________________________________________
//AB HIER infinite scroll / endless scroll inklusive Position Wiederherstellung bei Klick auf zurück

document.addEventListener('DOMContentLoaded', function() {
  const productList = document.querySelector('.ajaxloop');
  if (!productList) return;

  let nextPageUrl = document.querySelector('.pagination__next')?.href || null;
  let isLoading = false;
  let isRestoring = false;

  const buffer = 2600;
  const STATE_TTL = 30 * 60 * 1000;

  let checkpoints = [];

  function getNormalizedPageKey() {
    const url = new URL(window.location.href);
    const allowedParams = new URLSearchParams();

    const allowedExact = ['sort_by', 'q', 'constraint', 'view'];
    const allowedPrefixes = ['filter.'];

    url.searchParams.forEach(function(value, key) {
      const isAllowedExact = allowedExact.indexOf(key) !== -1;
      const isAllowedPrefix = allowedPrefixes.some(function(prefix) {
        return key.indexOf(prefix) === 0;
      });

      if (isAllowedExact || isAllowedPrefix) {
        allowedParams.append(key, value);
      }
    });

    const search = allowedParams.toString();
    return url.pathname + (search ? '?' + search : '');
  }

  const pageKey = getNormalizedPageKey();
  const stateKey = 'infscroll:' + pageKey;

  function isFresh(ts) {
    return typeof ts === 'number' && Date.now() - ts <= STATE_TTL;
  }

  function getCurrentItemCount() {
    return productList.querySelectorAll('.loopload').length;
  }

  function normalizeProductPath(href) {
    try {
      const url = new URL(href, window.location.origin);
      let path = url.pathname.replace(/\/+$/, '');
      path = path.replace(/^\/collections\/[^/]+\/products\//, '/products/');
      return path;
    } catch (e) {
      return null;
    }
  }

  function getProductLinkFromEventTarget(target) {
    const link = target.closest('a[href*="/products/"]');

    if (!link || !productList.contains(link)) {
      return null;
    }

    return link;
  }

  function cloneCheckpoints(input) {
    if (!Array.isArray(input)) return [];

    return input
      .filter(function(cp) {
        return cp && typeof cp.count === 'number';
      })
      .map(function(cp) {
        return {
          count: cp.count,
          nextPageUrl: cp.nextPageUrl || null
        };
      });
  }

  function sortAndDeduplicateCheckpoints() {
    const map = {};

    checkpoints.forEach(function(cp) {
      if (!cp || typeof cp.count !== 'number') return;

      map[cp.count] = {
        count: cp.count,
        nextPageUrl: cp.nextPageUrl || null
      };
    });

    checkpoints = Object.keys(map)
      .map(function(key) {
        return map[key];
      })
      .sort(function(a, b) {
        return a.count - b.count;
      });
  }

  function recordCheckpoint(count, nextUrl) {
    if (typeof count !== 'number' || count < 1) return;

    checkpoints.push({
      count: count,
      nextPageUrl: nextUrl || null
    });

    sortAndDeduplicateCheckpoints();
  }

  function getBestCheckpointForCount(count) {
    if (!Array.isArray(checkpoints) || !checkpoints.length) return null;

    let best = null;

    for (let i = 0; i < checkpoints.length; i++) {
      if (checkpoints[i].count <= count) {
        best = checkpoints[i];
      } else {
        break;
      }
    }

    return best;
  }

  function getState() {
    try {
      const raw = sessionStorage.getItem(stateKey);
      if (!raw) return null;

      const data = JSON.parse(raw);

      if (!isFresh(data.ts)) {
        sessionStorage.removeItem(stateKey);
        return null;
      }

      return data;
    } catch (e) {
      sessionStorage.removeItem(stateKey);
      return null;
    }
  }

  function saveState(clickedLink) {
    const itemCount = getCurrentItemCount();
    if (!itemCount) return;

    const previousState = getState();

    let targetPath = previousState && previousState.targetPath ? previousState.targetPath : null;
    let targetTopInViewport =
      previousState && typeof previousState.targetTopInViewport === 'number'
        ? previousState.targetTopInViewport
        : null;

    if (clickedLink) {
      const item = clickedLink.closest('.loopload');

      if (item) {
        const rect = item.getBoundingClientRect();
        targetPath = normalizeProductPath(clickedLink.href);
        targetTopInViewport = rect.top;
      }
    }

    const state = {
      scrollY: window.scrollY,
      itemCount: itemCount,
      targetPath: targetPath,
      targetTopInViewport: targetTopInViewport,
      checkpoints: cloneCheckpoints(checkpoints),
      ts: Date.now()
    };

    try {
      sessionStorage.setItem(stateKey, JSON.stringify(state));
    } catch (e) {}
  }

  function clearState() {
    try {
      sessionStorage.removeItem(stateKey);
    } catch (e) {}
  }

  function getNavType() {
    const navEntry = performance.getEntriesByType('navigation')[0];
    return navEntry ? navEntry.type : '';
  }

  function findTargetElement(savedState) {
    if (!savedState || !savedState.targetPath) return null;

    const links = productList.querySelectorAll('.loopload a[href*="/products/"]');

    for (let i = 0; i < links.length; i++) {
      const normalized = normalizeProductPath(links[i].href);

      if (normalized && normalized === savedState.targetPath) {
        return links[i].closest('.loopload');
      }
    }

    return null;
  }

  function setNextPageUrlForCurrentDom(savedState) {
    const currentCount = getCurrentItemCount();

    if (
      savedState &&
      Array.isArray(savedState.checkpoints) &&
      savedState.checkpoints.length
    ) {
      checkpoints = cloneCheckpoints(savedState.checkpoints);
      sortAndDeduplicateCheckpoints();

      const cp = getBestCheckpointForCount(currentCount);

      if (cp) {
        nextPageUrl = cp.nextPageUrl || null;
        return;
      }
    }

    const domNext = document.querySelector('.pagination__next');
    nextPageUrl = domNext ? domNext.href : null;
  }

  function appendNewItems(doc) {
    const newItems = doc.querySelectorAll('.loopload');

    newItems.forEach(function(item) {
      productList.appendChild(item);
    });
  }

  function loadMoreProducts(callback) {
    if (!nextPageUrl || isLoading) return;

    isLoading = true;

    fetch(nextPageUrl, { credentials: 'same-origin' })
      .then(function(res) {
        if (!res.ok) {
          throw new Error('HTTP-Fehler ' + res.status);
        }

        return res.text();
      })
      .then(function(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        appendNewItems(doc);

        const newNext = doc.querySelector('.pagination__next');
        nextPageUrl = newNext ? newNext.href : null;

        recordCheckpoint(getCurrentItemCount(), nextPageUrl);

        isLoading = false;

        if (typeof callback === 'function') {
          callback();
        }
      })
      .catch(function(err) {
        console.error('Fehler beim Nachladen:', err);
        isLoading = false;
      });
  }

  function scrollItemIntoPlace(item, savedState, done) {
    if (!item) {
      if (typeof done === 'function') done();
      return;
    }

    const desiredTop =
      typeof savedState.targetTopInViewport === 'number'
        ? savedState.targetTopInViewport
        : 120;

    let tries = 0;
    const maxTries = 16;

    function attempt() {
      const rect = item.getBoundingClientRect();
      const absoluteY = window.scrollY + rect.top - desiredTop;

      window.scrollTo(0, Math.max(0, absoluteY));

      requestAnimationFrame(function() {
        const newRect = item.getBoundingClientRect();
        const delta = Math.abs(newRect.top - desiredTop);

        if (delta <= 4 || tries >= maxTries) {
          if (typeof done === 'function') done();
          return;
        }

        tries += 1;
        window.setTimeout(attempt, 60);
      });
    }

    requestAnimationFrame(function() {
      requestAnimationFrame(attempt);
    });
  }

  function fallbackScrollRestore(savedState, done) {
    if (typeof savedState.scrollY !== 'number') {
      if (typeof done === 'function') done();
      return;
    }

    let tries = 0;
    const maxTries = 12;

    function attempt() {
      window.scrollTo(0, savedState.scrollY);

      requestAnimationFrame(function() {
        const delta = Math.abs(window.scrollY - savedState.scrollY);

        if (delta <= 4 || tries >= maxTries) {
          if (typeof done === 'function') done();
          return;
        }

        tries += 1;
        window.setTimeout(attempt, 50);
      });
    }

    requestAnimationFrame(function() {
      requestAnimationFrame(attempt);
    });
  }

  function restoreState(savedState) {
    if (!savedState || isRestoring) return;

    isRestoring = true;

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    window.scrollTo(0, 0);

    checkpoints = cloneCheckpoints(savedState.checkpoints);
    sortAndDeduplicateCheckpoints();

    setNextPageUrlForCurrentDom(savedState);

    function finishRestore() {
      isRestoring = false;
    }

    function stepRestore() {
      const targetItem = findTargetElement(savedState);
      const currentCount = getCurrentItemCount();
      const hasTarget = !!targetItem;
      const hasEnoughItems = currentCount >= savedState.itemCount;

      if (hasTarget && hasEnoughItems) {
        scrollItemIntoPlace(targetItem, savedState, finishRestore);
        return;
      }

      if (!savedState.targetPath) {
        if (hasEnoughItems || !nextPageUrl) {
          fallbackScrollRestore(savedState, finishRestore);
          return;
        }
      }

      if (!nextPageUrl) {
        if (hasTarget) {
          scrollItemIntoPlace(targetItem, savedState, finishRestore);
        } else {
          fallbackScrollRestore(savedState, finishRestore);
        }

        return;
      }

      loadMoreProducts(function() {
        window.setTimeout(stepRestore, 40);
      });
    }

    window.setTimeout(stepRestore, 0);
  }

  function maybeRestore(options) {
    if (isRestoring) return;

    const savedState = getState();
    if (!savedState) return;

    const isBFCache = options && options.isBFCache;
    const isBackForward = options && options.isBackForward;
    const isReload = options && options.isReload;

    if (isBFCache || isBackForward || isReload) {
      restoreState(savedState);
    }
  }

  recordCheckpoint(getCurrentItemCount(), nextPageUrl);

  const navType = getNavType();

  if (navType === 'back_forward' || navType === 'reload') {
    maybeRestore({
      isBackForward: navType === 'back_forward',
      isReload: navType === 'reload',
      isBFCache: false
    });
  } else {
    clearState();
  }

  window.addEventListener('pageshow', function(event) {
    maybeRestore({
      isBackForward: event.persisted || getNavType() === 'back_forward',
      isBFCache: !!event.persisted
    });
  });

  window.addEventListener('pagehide', function() {
    if (!isRestoring) {
      saveState();
    }
  });

  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden' && !isRestoring) {
      saveState();
    }
  });

  window.addEventListener(
    'scroll',
    function() {
      if (isRestoring || isLoading || !nextPageUrl) return;
      if (productList.offsetHeight < window.innerHeight) return;

      const containerBottom = productList.getBoundingClientRect().bottom;
      const viewportHeight = window.innerHeight;

      if (containerBottom - buffer <= viewportHeight) {
        loadMoreProducts();
      }
    },
    { passive: true }
  );

  productList.addEventListener('click', function(e) {
    const link = getProductLinkFromEventTarget(e.target);
    if (!link) return;

    const item = link.closest('.loopload');
    if (!item) return;

    saveState(link);
  });
});

//___________________________________________________________________
//BIS HIER infinite scroll


var mobilebreakpoint = 753;

// LOGO wird BEI DESKTOP ANWENDUNG nach rechts geschoben bei Klick ins Suchfeld
document.addEventListener('DOMContentLoaded', function() {
  var desktopInput = document.querySelector('.header-bar__search-input[type="search"]');
  var header = document.getElementById('top-bar-header');
  var closeDesktopButton = document.getElementById('close-search-desktop');
  var desktopForm = document.querySelector('.header-bar__search-form');

  var searchOpen = false;

  if (!desktopInput || !header || !closeDesktopButton || !desktopForm) return;

  function openSearchDesktop() {
    if (window.innerWidth > 768 && !searchOpen) {
      header.classList.add('is-search-open');

      window.setTimeout(function() {
        closeDesktopButton.classList.add('show');
      }, 400);

      searchOpen = true;
    }
  }

  function closeSearchDesktop() {
    if (window.innerWidth > 768 && searchOpen) {
      desktopInput.blur();

      if (typeof window.closePredictiveSearchResults === 'function') {
        window.closePredictiveSearchResults();
      } else {
        document.querySelectorAll('.search-results').forEach(function(el) {
          el.style.display = 'none';
          el.innerHTML = '';
        });
      }

      header.classList.remove('is-search-open');
      closeDesktopButton.classList.remove('show');

      searchOpen = false;
    }
  }

  desktopInput.addEventListener('focus', openSearchDesktop);

  closeDesktopButton.addEventListener('click', function() {
    closeSearchDesktop();
  });

  closeDesktopButton.addEventListener('contextmenu', function(e) {
    e.preventDefault();
    closeSearchDesktop();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeSearchDesktop();
    }
  });

  document.addEventListener('click', function(e) {
    if (
      window.innerWidth > 768 &&
      !desktopForm.contains(e.target) &&
      !closeDesktopButton.contains(e.target)
    ) {
      closeSearchDesktop();
    }
  });
});


// START collection pills (auch graue Abschlusslinie unten am header wenn sticky)

/* --- Sticky-Header-Klasse toggeln --------------------------------------- */
window.addEventListener(
  'scroll',
  function() {
    var header = document.getElementById('shopify-section-header');
    if (!header) return;

    if (window.scrollY > 0) {
      header.classList.add('is-sticky');
    } else {
      header.classList.remove('is-sticky');
    }
  },
  { passive: true }
);

/* --- Headerhöhe -> CSS-Var, inkl. Reflow-Fix nach Menüzustandswechsel --- */
function updateStickyPillsOffset() {
  var header = document.getElementById('shopify-section-header');
  if (!header) return;

  var headerHeight = header.offsetHeight || 0;
  document.documentElement.style.setProperty('--sticky-pills-offset', headerHeight + 'px');
}

/* --- Initialisierung & Beobachter -------------------------------------- */
document.addEventListener('DOMContentLoaded', function() {
  updateStickyPillsOffset();

  var header = document.getElementById('shopify-section-header');

  if (header && 'ResizeObserver' in window) {
    var ro = new ResizeObserver(function() {
      updateStickyPillsOffset();
    });

    ro.observe(header);
  }

  var targets = [document.body, header].filter(Boolean);

  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function() {
      updateStickyPillsOffset();
    });

    targets.forEach(function(node) {
      mo.observe(node, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    });
  }

  window.setTimeout(function() {
    updateStickyPillsOffset();
  }, 100);
});

window.addEventListener('resize', function() {
  updateStickyPillsOffset();
});

window.addEventListener('orientationchange', function() {
  updateStickyPillsOffset();
});

/* --- Pfeil-Buttons + Desktop Wheel-Mapping (an .collection-pills-inner) - */
(function() {
  function initPillsArrows() {
    var wrapper = document.querySelector('.collection-pills-wrapper');
    var inner = wrapper ? wrapper.querySelector('.collection-pills-inner') : null;
    var scroller = inner ? inner.querySelector('.collection-pills-scroll') : null;

    if (!wrapper || !inner || !scroller || inner.__pillsNavInit) return;

    inner.__pillsNavInit = true;

    var leftBtn = document.createElement('button');
    var rightBtn = document.createElement('button');

    leftBtn.className = 'pills-nav pills-nav--left';
    rightBtn.className = 'pills-nav pills-nav--right';

    leftBtn.setAttribute('type', 'button');
    rightBtn.setAttribute('type', 'button');

    leftBtn.setAttribute('aria-label', 'Nach links scrollen');
    rightBtn.setAttribute('aria-label', 'Nach rechts scrollen');

    leftBtn.textContent = '‹';
    rightBtn.textContent = '›';

    inner.appendChild(leftBtn);
    inner.appendChild(rightBtn);

    function updateButtons() {
      var hasOverflow = scroller.scrollWidth > scroller.clientWidth + 2;

      wrapper.classList.toggle('pills--has-overflow', hasOverflow);

      leftBtn.hidden = !hasOverflow;
      rightBtn.hidden = !hasOverflow;

      if (!hasOverflow) {
        wrapper.classList.remove('pills--at-start', 'pills--at-end');
        return;
      }

      var max = scroller.scrollWidth - scroller.clientWidth - 1;
      var atStart = scroller.scrollLeft <= 2;
      var atEnd = scroller.scrollLeft >= max - 2;

      wrapper.classList.toggle('pills--at-start', atStart);
      wrapper.classList.toggle('pills--at-end', atEnd);

      leftBtn.disabled = atStart;
      rightBtn.disabled = atEnd;

      leftBtn.style.opacity = atStart ? '0.35' : '0.9';
      rightBtn.style.opacity = atEnd ? '0.35' : '0.9';
    }

    function step(dir) {
      var px = Math.max(200, scroller.clientWidth * 0.6) * dir;

      scroller.scrollBy({
        left: px,
        behavior: 'smooth'
      });

      window.setTimeout(updateButtons, 250);
    }

    leftBtn.addEventListener('click', function() {
      step(-1);
    });

    rightBtn.addEventListener('click', function() {
      step(1);
    });

    var isTouch = window.matchMedia('(hover: none)').matches;

    scroller.addEventListener(
      'wheel',
      function(e) {
        if (!isTouch && Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          scroller.scrollLeft += e.deltaY;
          e.preventDefault();
          updateButtons();
        }
      },
      { passive: false }
    );

    scroller.addEventListener('scroll', updateButtons, { passive: true });

    window.addEventListener('resize', updateButtons);

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateButtons).observe(scroller);
    }

    updateButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPillsArrows);
  } else {
    initPillsArrows();
  }

  if ('MutationObserver' in window) {
    new MutationObserver(initPillsArrows).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();

// Klick auf aktive Pille ist wie ein Zurück-Button zu verwenden. Scrollposition wiederherstellen.
document.addEventListener('click', function(e) {
  var link = e.target.closest('.collection-pill--active');
  if (!link) return;

  var hasOrigin = false;

  try {
    var params = new URLSearchParams(window.location.search);
    hasOrigin = params.has('origin_collection');
  } catch (err) {
    hasOrigin = false;
  }

  if (!hasOrigin) {
    var ref = document.referrer || '';
    var cameFromCollection = ref.indexOf('/collections/') !== -1;

    if (cameFromCollection && window.history.length > 1) {
      e.preventDefault();
      window.history.back();
      return;
    }
  }
});


// aktive Pille für Search-Ergebnisse
document.addEventListener('DOMContentLoaded', function() {
  try {
    var params = new URLSearchParams(window.location.search);
    var originHandle = (params.get('origin_collection') || '').toLowerCase();

    if (!originHandle) return;

    var scroller = document.querySelector('.collection-pills-scroll');
    if (!scroller) return;

    if (document.querySelector('.collection-pill--active')) return;

    var pills = Array.prototype.slice.call(scroller.querySelectorAll('.collection-pill'));
    var pattern = '/collections/' + originHandle;
    var target = null;

    pills.forEach(function(pill) {
      if (target) return;

      var href = pill.getAttribute('href') || '';

      if (href.indexOf(pattern) !== -1) {
        target = pill;
      }
    });

    if (target) {
      target.classList.add('collection-pill--active');

      var firstPill = scroller.querySelector('.collection-pill');

      if (firstPill && firstPill !== target) {
        scroller.insertBefore(target, firstPill);
      }

      scroller.scrollTo({
        left: 0,
        behavior: 'auto'
      });
    }
  } catch (e) {}
});

// ENDE collection pills


// AB HIER DESKTOP-DROPDOWN-MENÜ neu
document.addEventListener('DOMContentLoaded', function() {
  var menuItems = Array.prototype.slice.call(
    document.querySelectorAll('.site-nav .has-dropdown')
  );

  if (!menuItems.length) return;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var openTimer = null;
  var closeTimer = null;
  var OPEN_DELAY = 90;
  var CLOSE_DELAY = 180;

  function setExpanded(item, expanded) {
    var trigger = item.querySelector('.nav-link');
    if (trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  function closeItem(item) {
    item.classList.remove('menu-open');
    setExpanded(item, false);
  }

  function openItem(item) {
    menuItems.forEach(function(otherItem) {
      if (otherItem !== item) {
        closeItem(otherItem);
      }
    });

    item.classList.add('menu-open');
    setExpanded(item, true);
  }

  function closeAll() {
    menuItems.forEach(function(item) {
      closeItem(item);
    });
  }

  menuItems.forEach(function(item) {
    var trigger = item.querySelector('.nav-link');
    if (!trigger) return;

    trigger.addEventListener('pointerup', function(e) {
      e.preventDefault();
      e.stopPropagation();

      clearTimeout(openTimer);
      clearTimeout(closeTimer);

      if (item.classList.contains('menu-open')) {
        closeItem(item);
      } else {
        openItem(item);
      }
    });

    item.addEventListener('mouseenter', function() {
      if (!canHover.matches) return;

      clearTimeout(openTimer);
      clearTimeout(closeTimer);

      openTimer = setTimeout(function() {
        openItem(item);
      }, OPEN_DELAY);
    });

    item.addEventListener('mouseleave', function() {
      if (!canHover.matches) return;

      clearTimeout(openTimer);
      clearTimeout(closeTimer);

      closeTimer = setTimeout(function() {
        closeItem(item);
      }, CLOSE_DELAY);
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.site-nav .has-dropdown')) {
      closeAll();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeAll();
    }
  });
});

//Der erste und vierte collection slider wird bei mobile ruckartig animiert um den 
//user zu zeigen dass er nach rechts scrollen kann
//Wenn die 2. Animation gelaufen ist, wird ein Wert in localstorage geschrieben,
//damit die Animation nicht immer wieder gezeigt wird
//Erst nach einer eingestellten Zeit wird die Animation wieder gezeigt
var expirationDuration = 1000 * 60 * 60 * 24; // 24 Stunden
var storageKey = 'animation-slider';
var prevAccepted = localStorage.getItem(storageKey);
var currentTime = Date.now();

var notAccepted = prevAccepted == null;
var prevAcceptedExpired =
  prevAccepted != null && currentTime - parseInt(prevAccepted, 10) > expirationDuration;

if (notAccepted || prevAcceptedExpired) {
  document.addEventListener('DOMContentLoaded', function() {
    var sliders = Array.prototype.slice.call(
      document.querySelectorAll(
        '.section-collectionslider-ages .age-slider-grid, ' +
          '.flex-slider-featured, ' +
          '.section-collectionslider-brands .age-slider-grid, ' +
          '.mk-age-slider__track, ' +
          '.mk-brand-slider__track, ' +
          '.mk-product-slider-v2__track'
      )
    );

    var firstslider = sliders[0];
    var fourthslider = sliders[2];

    if (window.innerWidth < mobilebreakpoint) {
      if (firstslider) {
        var firstSliderScrollHandler = function() {
          var firstsliderposition =
            firstslider.getBoundingClientRect().top +
            window.pageYOffset +
            firstslider.offsetHeight;

          if (window.pageYOffset + window.innerHeight > firstsliderposition - 140) {
            animateHorizontalScroll(firstslider, 75, 500, function() {
              animateHorizontalScroll(firstslider, -75, 500);
            });

            window.removeEventListener('scroll', firstSliderScrollHandler);
          }
        };

        window.addEventListener('scroll', firstSliderScrollHandler, { passive: true });
      }

      if (fourthslider) {
        var fourthSliderScrollHandler = function() {
          var fourthsliderposition =
            fourthslider.getBoundingClientRect().top +
            window.pageYOffset +
            fourthslider.offsetHeight;

          if (window.pageYOffset + window.innerHeight > fourthsliderposition - 140) {
            animateHorizontalScroll(fourthslider, 75, 500, function() {
              animateHorizontalScroll(fourthslider, -75, 500);
            });

            window.removeEventListener('scroll', fourthSliderScrollHandler);
            localStorage.setItem(storageKey, String(currentTime));
          }
        };

        window.addEventListener('scroll', fourthSliderScrollHandler, { passive: true });
      }
    }
  });
}

function animateHorizontalScroll(element, distance, duration, callback) {
  var start = element.scrollLeft;
  var startTime = null;

  function step(timestamp) {
    if (!startTime) {
      startTime = timestamp;
    }

    var progress = Math.min((timestamp - startTime) / duration, 1);
    element.scrollLeft = start + distance * progress;

    if (progress < 1) {
      window.requestAnimationFrame(step);
    } else if (typeof callback === 'function') {
      callback();
    }
  }

  window.requestAnimationFrame(step);
}


// document.getElementById('paypal-animation-container').remove();

document.addEventListener('DOMContentLoaded', function() {
  var backToTopBtn = document.getElementById('myBtn');
  if (!backToTopBtn) return;

  var mobileMq = window.matchMedia('(max-width: 768px)');

  backToTopBtn.addEventListener('click', function() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });

  function toggleBackToTop() {
    if (!mobileMq.matches) {
      backToTopBtn.style.display = 'none';
      return;
    }

    var scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    backToTopBtn.style.display = scrollTop > 150 ? 'flex' : 'none';
  }

  window.addEventListener('scroll', toggleBackToTop, { passive: true });

  if (typeof mobileMq.addEventListener === 'function') {
    mobileMq.addEventListener('change', toggleBackToTop);
  } else if (typeof mobileMq.addListener === 'function') {
    mobileMq.addListener(toggleBackToTop);
  }

  toggleBackToTop();
});


// START Überschrift "Seite X" einblenden, wenn ?page= in der URL ist
document.addEventListener('DOMContentLoaded', function() {
  var url = new URL(window.location.href);

  if (url.pathname.indexOf('/collections/') === -1) return;

  var pageParam = url.searchParams.get('page');
  if (!pageParam) return;

  var pageNumber = parseInt(pageParam, 10);
  if (isNaN(pageNumber) || pageNumber <= 1) return;

  var title = document.querySelector('.section-header__title');
  if (!title) return;

  url.searchParams.delete('page');

  var collLink = url.origin + url.pathname + (url.search ? url.search : '');

  var baseText = title.textContent.replace(/\s+- Seite\s+\d+.*$/, '');
  title.textContent = baseText + ' - Seite ' + pageNumber + ' ';

  if (!title.querySelector('.linknachobenzurueck')) {
    var link = document.createElement('a');
    link.className = 'linknachobenzurueck';
    link.href = collLink;
    link.textContent = '(zurück zu Seite 1)';

    title.appendChild(link);
  }
});
// ENDE Überschrift "Seite 2" zb wird eingeblendet


document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth >= 768) return;

  var BadgeExpirationDuration = 1000 * 60 * 60; // 1 Stunde
  var prevBadgeTimeRaw = localStorage.getItem('review-badge');
  var prevBadgeTime = prevBadgeTimeRaw ? parseInt(prevBadgeTimeRaw, 10) : null;
  var currentTime = Date.now();

  var notSeenBefore = prevBadgeTime === null;
  var expired =
    prevBadgeTime !== null &&
    currentTime - prevBadgeTime > BadgeExpirationDuration;

  var badge = document.getElementById('review-badge');
  if (!badge) return;

  if (notSeenBefore || expired) {

    badge.style.display = 'block';
    badge.style.opacity = '1';

    window.setTimeout(function() {
      badge.style.transition = 'opacity 600ms ease';
      badge.style.opacity = '0';

      window.setTimeout(function() {
        badge.style.display = 'none';
      }, 600);

    }, 8000);

    localStorage.setItem('review-badge', String(currentTime));

  } else {
    badge.style.display = 'none';
  }
});

function fadeOut(element, duration) {
  var start = null;
  var initialOpacity = parseFloat(window.getComputedStyle(element).opacity) || 1;

  function step(timestamp) {
    if (!start) {
      start = timestamp;
    }

    var progress = Math.min((timestamp - start) / duration, 1);
    element.style.opacity = String(initialOpacity * (1 - progress));

    if (progress < 1) {
      window.requestAnimationFrame(step);
    } else {
      element.style.display = 'none';
      element.style.opacity = '';
    }
  }

  window.requestAnimationFrame(step);
}


document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.faq-frage').forEach(function(question) {
    question.addEventListener('click', function() {
      const parent = question.closest('.faq-punkt');
      if (!parent) return;

      parent.classList.toggle('is-open');
    });
  });
});


// Vendor-Text aus- / einblenden
document.addEventListener('DOMContentLoaded', function() {
  var toggles = document.querySelectorAll('.vendor-text-toggle');

  if (!toggles.length) return;

  toggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var container = toggle.closest('.content-vendor-text');
      if (!container) return;

      var isExpanded = container.classList.contains('expanded');

      if (isExpanded) {
        container.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }

      container.classList.toggle('expanded');
      toggle.textContent = isExpanded ? 'mehr...' : 'weniger';
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  var toggleButton = document.getElementById('search-toggle');
  var searchContainer = document.getElementById('search-container');
  var overlay = document.getElementById('search-overlay');
  var closeButton = document.getElementById('close-search');
  var searchForm = document.querySelector('#search-container form');

  if (!toggleButton || !searchContainer || !overlay) {
    return;
  }

  function closeSearch() {
    searchContainer.classList.remove('active');
    overlay.classList.add('hidden');
    document.body.classList.remove('no-scroll');
  }

  toggleButton.addEventListener('click', function() {
    var isOpen = searchContainer.classList.contains('active');

    if (isOpen) {
      closeSearch();
    } else {
      searchContainer.classList.add('active');
      overlay.classList.remove('hidden');
      document.body.classList.add('no-scroll');

      var input = searchContainer.querySelector('input[type="search"]');

      if (input) {
        input.focus();
      }
    }
  });

  overlay.addEventListener('click', closeSearch);

  if (closeButton) {
    closeButton.addEventListener('click', closeSearch);
  }

  if (searchForm) {
    searchForm.addEventListener('submit', function() {
      closeSearch();
    });
  }

  document.addEventListener('click', function(e) {
    var clickedInsideSearch = searchContainer.contains(e.target);
    var clickedToggleButton = toggleButton.contains(e.target);

    if (!clickedInsideSearch && !clickedToggleButton) {
      closeSearch();
    }
  });
});


// Ab hier für 2. Bild bei hover
(function() {
  var INTERACTION_MODE = 'hold';
  var HOLD_DELAY = 100;
  var EXCLUSIVE_STICKY = true;
  var fineHoverMq = window.matchMedia
    ? window.matchMedia('(hover:hover) and (pointer:fine) and (min-width: 750px)')
    : null;
  var isFineHover = fineHoverMq ? fineHoverMq.matches : false;
  var EAGER_COUNT = isFineHover ? 6 : 0;
  var PREFETCH_ROOT_MARGIN = '400px 0px';
  var WRAPPER_SELECTOR = '.product__img-wrapper.hover-swap';
  var CONTAINER_SELECTOR = '.ajaxloop';

  var ioPrefetch =
    'IntersectionObserver' in window && isFineHover
      ? new IntersectionObserver(
          function(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                ensureSecondaryLoaded(entry.target);
                ioPrefetch.unobserve(entry.target);
              }
            });
          },
          { rootMargin: PREFETCH_ROOT_MARGIN }
        )
      : null;

  var ioReset =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function(entries) {
            entries.forEach(function(entry) {
              if (!entry.isIntersecting) {
                entry.target.classList.remove('is-hover');
              }
            });
          },
          { threshold: 0 }
        )
      : null;

  function ensureSecondaryLoaded(wrap) {
    var img = wrap.querySelector('.product__img--secondary');

    if (img && img.getAttribute('data-loaded') === '1') return;

    var data = wrap.querySelector('.product__secondary-image-data');
    if (!data) return;

    if (!img) {
      img = document.createElement('img');
      img.className = 'product__img product__img--secondary';
      img.alt = data.getAttribute('data-alt') || '';
      img.loading = 'lazy';
      img.decoding = 'async';

      img.addEventListener(
        'load',
        function() {
          img.classList.add('is-ready');
        },
        { once: true }
      );

      img.srcset = data.getAttribute('data-srcset') || '';
      img.sizes = data.getAttribute('data-sizes') || '304px';
      img.src = data.getAttribute('data-src') || '';

      var mediaFrame = wrap.querySelector('.product__media-frame');

      if (mediaFrame) {
        mediaFrame.appendChild(img);
      }
    }

    img.setAttribute('data-loaded', '1');
  }

  function isOn(wrap) {
    return wrap.classList.contains('is-hover');
  }

  function turnOn(wrap) {
    if (EXCLUSIVE_STICKY) {
      document.querySelectorAll(WRAPPER_SELECTOR + '.is-hover').forEach(function(activeWrap) {
        if (activeWrap !== wrap) {
          activeWrap.classList.remove('is-hover');
        }
      });
    }

    ensureSecondaryLoaded(wrap);
    wrap.classList.add('is-hover');
  }

  function turnOff(wrap) {
    wrap.classList.remove('is-hover');
  }

  function bindWrapper(wrap) {
    if (!wrap || wrap.getAttribute('data-swap-bound') === '1') return;

    if (
      !wrap.querySelector('.product__img--secondary') &&
      !wrap.querySelector('.product__secondary-image-data')
    ) {
      wrap.setAttribute('data-swap-bound', '1');
      return;
    }

    wrap.addEventListener(
      'mouseenter',
      function() {
        if (
          window.matchMedia &&
          window.matchMedia('(hover:hover) and (pointer:fine)').matches
        ) {
          ensureSecondaryLoaded(wrap);
        }
      },
      { passive: true }
    );

    wrap.addEventListener('focusin', function() {
      ensureSecondaryLoaded(wrap);
    });

    if (INTERACTION_MODE === 'hold') {
      var holdTimer = null;
      var started = false;

      var start = function() {
        if (started) return;

        started = true;

        holdTimer = window.setTimeout(function() {
          if (isOn(wrap)) {
            turnOff(wrap);
          } else {
            turnOn(wrap);
          }
        }, HOLD_DELAY);
      };

      var clear = function() {
        started = false;

        if (holdTimer) {
          window.clearTimeout(holdTimer);
          holdTimer = null;
        }
      };

      wrap.addEventListener(
        'touchstart',
        function() {
          ensureSecondaryLoaded(wrap);
        },
        { passive: true }
      );

      wrap.addEventListener('pointerdown', function(e) {
        if (e.pointerType !== 'mouse') {
          ensureSecondaryLoaded(wrap);
        }
      });

      wrap.addEventListener('touchstart', start, { passive: true });
      wrap.addEventListener('touchend', clear);
      wrap.addEventListener('touchcancel', clear);
      wrap.addEventListener('touchmove', clear, { passive: true });

      wrap.addEventListener('pointerdown', function(e) {
        if (e.pointerType !== 'mouse') {
          start();
        }
      });

      wrap.addEventListener('pointerup', clear);
      wrap.addEventListener('pointercancel', clear);
      wrap.addEventListener('pointerleave', clear);
    } else if (INTERACTION_MODE === 'tap') {
      var link = wrap.closest('a');
      var target = link || wrap;

      target.addEventListener(
        'touchstart',
        function() {
          ensureSecondaryLoaded(wrap);
        },
        { passive: true }
      );

      target.addEventListener('pointerdown', function(e) {
        if (e.pointerType !== 'mouse') {
          ensureSecondaryLoaded(wrap);
        }
      });

      target.addEventListener(
        'click',
        function(e) {
          if (e.pointerType === 'mouse') return;

          if (!isOn(wrap)) {
            e.preventDefault();
            e.stopPropagation();
            turnOn(wrap);
          }
        },
        { capture: true }
      );
    }

    if (ioReset) {
      ioReset.observe(wrap);
    }

    if (ioPrefetch) {
      ioPrefetch.observe(wrap);
    }

    wrap.setAttribute('data-swap-bound', '1');
  }

  function initAll() {
    var wrappers = Array.prototype.slice
      .call(document.querySelectorAll(WRAPPER_SELECTOR))
      .filter(function(wrap) {
        return !wrap.getAttribute('data-swap-bound');
      });

    var isFirstInit = !document.documentElement.getAttribute('data-swap-init-done');

    if (isFirstInit) {
      wrappers.slice(0, EAGER_COUNT).forEach(function(wrap) {
        ensureSecondaryLoaded(wrap);
      });

      document.documentElement.setAttribute('data-swap-init-done', '1');
    }

    wrappers.forEach(bindWrapper);
  }

  function installMutationObserver() {
    var container = document.querySelector(CONTAINER_SELECTOR) || document.body;

    if (!('MutationObserver' in window) || !container) return;

    var mo = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        Array.prototype.slice.call(mutation.addedNodes).forEach(function(node) {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches && node.matches(WRAPPER_SELECTOR)) {
            bindWrapper(node);
          }

          if (node.querySelectorAll) {
            node.querySelectorAll(WRAPPER_SELECTOR).forEach(bindWrapper);
          }
        });
      });
    });

    mo.observe(container, {
      childList: true,
      subtree: true
    });
  }

  window.mekiSwapInit = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll();
      installMutationObserver();
    });
  } else {
    initAll();
    installMutationObserver();
  }
})();


/* =========================================
   Smart shrink header (mobile)
   Elegant gegen "mini up scroll" -> kein sofortiges Expand
   - Downscroll => compact (schnell)
   - Upscroll   => normal (erst nach deutlicher Up-Bewegung ODER nahe Top)
   - Lock + Menu-Pause bleibt drin
   ========================================= */
(function () {
  var header = document.getElementById("top-bar-header");
  if (!header) return;

  var ann = header.querySelector(".announcement-bar--mobile");
  var startThreshold = (ann ? ann.offsetHeight : 0) + 10;

  var SHRINK_PX = 20;
  var EXPAND_PX = 100;
  var EXPAND_TOP_Y = 120;
  var LOCK_MS = 180;
  var MIN_DELTA = 2;
  var MENU_PAUSE_MS = 260;

  var prevY = window.scrollY || 0;
  var maxY = prevY;
  var isCompact = header.classList.contains("is-compact");
  var lockedUntil = 0;
  var pauseUntil = 0;
  var ticking = false;

  document.addEventListener(
    "click",
    function (e) {
      var trigger = e.target.closest(".mobile-nav__sublist-trigger");
      if (!trigger) return;
      pauseUntil = Date.now() + MENU_PAUSE_MS;
    },
    true
  );

  function setCompact(next) {
    if (next === isCompact) return;
    isCompact = next;
    header.classList.toggle("is-compact", next);
    lockedUntil = Date.now() + LOCK_MS;
    maxY = window.scrollY || 0;
  }

  function apply() {
    var y = window.scrollY || 0;
    var now = Date.now();

    if (now < pauseUntil) {
      prevY = y;
      ticking = false;
      return;
    }

    if (y <= 2 || y < EXPAND_TOP_Y) {
      setCompact(false);
      prevY = y;
      maxY = y;
      ticking = false;
      return;
    }

    var delta = y - prevY;

    if (Math.abs(delta) < MIN_DELTA) {
      prevY = y;
      ticking = false;
      return;
    }

    if (now < lockedUntil) {
      prevY = y;
      maxY = Math.max(maxY, y);
      ticking = false;
      return;
    }

    maxY = Math.max(maxY, y);

    var scrollingDown = delta > 0;
    var scrolledUpFromPeak = maxY - y;

    if (!isCompact && scrollingDown && y > startThreshold + SHRINK_PX) {
      setCompact(true);
    }

    if (isCompact && !scrollingDown && scrolledUpFromPeak > EXPAND_PX) {
      setCompact(false);
    }

    prevY = y;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(apply);
      ticking = true;
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  apply();
})();


// Mobile Navigation 2026 mobile-nav
(function () {
  var trigger = document.getElementById("MobileDrawerNavTrigger");
  var drawer = document.getElementById("MobileDrawerNav");

  if (!trigger || !drawer) return;

  var overlay = drawer.querySelector(".mnav__overlay");
  var closeBtn = drawer.querySelector(".mnav__close");
  var panel = drawer.querySelector(".mnav__panel");
  var toggles = drawer.querySelectorAll(".mnav__toggle-row");
  var focusableSelector =
    'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var swipe = {
    startX: 0,
    startY: 0,
    deltaX: 0,
    deltaY: 0,
    tracking: false,
    active: false
  };

  var lastFocusedElement = null;
  var scrollY = 0;
  var isAnimating = false;

  function getFocusableElements() {
    return drawer.querySelectorAll(focusableSelector);
  }

  function lockBodyScroll() {
    scrollY = window.scrollY || window.pageYOffset;
    document.documentElement.classList.add("mnav-open");
    document.body.classList.add("mnav-open");
    document.body.style.top = -scrollY + "px";
  }

  function unlockBodyScroll() {
    document.documentElement.classList.remove("mnav-open");
    document.body.classList.remove("mnav-open");
    document.body.style.top = "";
    window.scrollTo(0, scrollY);
  }

  function openDrawer() {
    if (isAnimating || drawer.classList.contains("is-visible")) return;
    isAnimating = true;

    lastFocusedElement = document.activeElement;
    drawer.hidden = false;

    window.requestAnimationFrame(function () {
      drawer.classList.add("is-visible");
      trigger.setAttribute("aria-expanded", "true");
      lockBodyScroll();

      var firstFocusable = drawer.querySelector(".mnav__close");
      if (firstFocusable) firstFocusable.focus();

      window.setTimeout(function () {
        isAnimating = false;
      }, 320);
    });

    document.addEventListener("keydown", onKeydown);
  }

  function closeDrawer() {
    if (isAnimating || !drawer.classList.contains("is-visible")) return;
    isAnimating = true;

    resetDrawerState();
    drawer.classList.remove("is-visible");
    trigger.setAttribute("aria-expanded", "false");
    document.removeEventListener("keydown", onKeydown);

    window.setTimeout(function () {
      drawer.hidden = true;
      unlockBodyScroll();
      if (lastFocusedElement) lastFocusedElement.focus();
      isAnimating = false;
    }, 320);
  }

  function closeSiblingItems(currentItem) {
    var parentList = currentItem.parentElement;
    if (!parentList) return;

    Array.prototype.forEach.call(parentList.children, function (item) {
      if (item !== currentItem) {
        item.classList.remove("is-open");

        var siblingButton = item.querySelector(":scope > .mnav__toggle-row");
        if (siblingButton) {
          siblingButton.setAttribute("aria-expanded", "false");
        }
      }
    });
  }

  function resetDrawerState() {
    var openItems = drawer.querySelectorAll(".mnav__item.is-open");
    Array.prototype.forEach.call(openItems, function (item) {
      item.classList.remove("is-open");
    });

    var expandedButtons = drawer.querySelectorAll(
      '.mnav__toggle-row[aria-expanded="true"]'
    );
    Array.prototype.forEach.call(expandedButtons, function (button) {
      button.setAttribute("aria-expanded", "false");
    });
  }

  function toggleItem(button) {
    var item = button.closest(".mnav__item");
    if (!item) return;

    var isOpen = item.classList.contains("is-open");

    if (isOpen) {
      item.classList.remove("is-open");
      button.setAttribute("aria-expanded", "false");
    } else {
      closeSiblingItems(item);
      item.classList.add("is-open");
      button.setAttribute("aria-expanded", "true");
    }
  }

  function onKeydown(evt) {
    if (evt.key === "Escape") {
      closeDrawer();
      return;
    }

    if (evt.key === "Tab") {
      var focusable = getFocusableElements();
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (evt.shiftKey && document.activeElement === first) {
        evt.preventDefault();
        last.focus();
      } else if (!evt.shiftKey && document.activeElement === last) {
        evt.preventDefault();
        first.focus();
      }
    }
  }

  trigger.addEventListener("click", function () {
    if (drawer.classList.contains("is-visible")) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  if (overlay) {
    overlay.addEventListener("click", closeDrawer);
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", closeDrawer);
  }

  Array.prototype.forEach.call(toggles, function (button) {
    button.addEventListener("click", function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      toggleItem(button);
    });
  });

  function isMobileDrawerSwipeEnabled() {
    return window.matchMedia("(max-width: 768px)").matches;
  }

  function bindSwipeToClose() {
    if (!panel) return;

    panel.addEventListener(
      "touchstart",
      function (e) {
        if (!isMobileDrawerSwipeEnabled()) return;
        if (!drawer.classList.contains("is-visible")) return;
        if (!e.touches || e.touches.length !== 1) return;

        var touch = e.touches[0];

        swipe.startX = touch.clientX;
        swipe.startY = touch.clientY;
        swipe.deltaX = 0;
        swipe.deltaY = 0;
        swipe.tracking = true;
        swipe.active = false;
      },
      { passive: true }
    );

    panel.addEventListener(
      "touchmove",
      function (e) {
        if (!isMobileDrawerSwipeEnabled()) return;
        if (!swipe.tracking) return;
        if (!e.touches || e.touches.length !== 1) return;

        var touch = e.touches[0];

        swipe.deltaX = touch.clientX - swipe.startX;
        swipe.deltaY = touch.clientY - swipe.startY;

        var absX = Math.abs(swipe.deltaX);
        var absY = Math.abs(swipe.deltaY);

        if (!swipe.active) {
          if (absX < 12 && absY < 12) return;

          if (swipe.deltaX < 0 && absX > absY * 1.4) {
            swipe.active = true;
          } else if (absY > absX) {
            swipe.tracking = false;
            return;
          }
        }

        if (swipe.active) {
          e.preventDefault();
        }
      },
      { passive: false }
    );

    panel.addEventListener(
      "touchend",
      function () {
        if (!isMobileDrawerSwipeEnabled()) {
          swipe.tracking = false;
          swipe.active = false;
          return;
        }

        if (!swipe.tracking) {
          swipe.active = false;
          return;
        }

        var absX = Math.abs(swipe.deltaX);
        var absY = Math.abs(swipe.deltaY);

        var isLeftSwipe = swipe.deltaX < -70;
        var isMostlyHorizontal = absX > absY * 1.4;

        if (swipe.active && isLeftSwipe && isMostlyHorizontal) {
          closeDrawer();
        }

        swipe.tracking = false;
        swipe.active = false;
        swipe.deltaX = 0;
        swipe.deltaY = 0;
      },
      { passive: true }
    );

    panel.addEventListener(
      "touchcancel",
      function () {
        swipe.tracking = false;
        swipe.active = false;
        swipe.deltaX = 0;
        swipe.deltaY = 0;
      },
      { passive: true }
    );
  }

  window.addEventListener("resize", function () {
    if (window.innerWidth > 768 && drawer.classList.contains("is-visible")) {
      closeDrawer();
    }
  });

  bindSwipeToClose();
})();

//___________ Image slider (flickity v2.0) - 2026 _________
(function() {
  "use strict";

  function mkCssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }

    return String(value).replace(/["\\]/g, "\\$&");
  }

  function mkParseProductJson() {
    var script = document.querySelector("script[id^='ProductJson-']");
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function mkGetSelectedVariantId() {
    var select = document.querySelector(".product-single__variants");
    if (!select) return null;

    var value = parseInt(select.value, 10);
    return isNaN(value) ? null : value;
  }

  function mkGetVariantImageId(product, variantId) {
    if (!product || !product.variants || !variantId) return null;

    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];

      if (variant.id === variantId) {
        if (variant.featured_image && variant.featured_image.id) {
          return variant.featured_image.id;
        }

        if (variant.featured_media && variant.featured_media.id) {
          return variant.featured_media.id;
        }
      }
    }

    return null;
  }

  function mkFindSlideIndexByImageId(gallery, imageId) {
    if (!gallery || !imageId) return 0;

    var slides = gallery.querySelectorAll("[data-mk-slide]");

    for (var i = 0; i < slides.length; i++) {
      var id = parseInt(slides[i].getAttribute("data-image-id"), 10);

      if (id === parseInt(imageId, 10)) {
        return i;
      }
    }

    return 0;
  }

  function mkScrollThumbIntoView(button) {
    if (!button || typeof button.scrollIntoView !== "function") return;

    button.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest"
    });
  }

  function mkFindVariantByImageId(product, imageId) {
    if (!product || !product.variants || !imageId) return null;

    var normalizedImageId = parseInt(imageId, 10);
    if (isNaN(normalizedImageId)) return null;

    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (!variant) continue;

      var variantImageId = null;

      if (variant.featured_image && variant.featured_image.id) {
        variantImageId = parseInt(variant.featured_image.id, 10);
      } else if (variant.featured_media && variant.featured_media.id) {
        variantImageId = parseInt(variant.featured_media.id, 10);
      }

      if (variantImageId === normalizedImageId) {
        return variant;
      }
    }

    return null;
  }

  var mkIsUpdatingVariant = false;

  function mkInitProductGallery() {
    var galleryRoot = document.querySelector("[data-mk-product-gallery]");
    var mkGalleryChangingFromVariant = false;
    if (!galleryRoot) return;
    if (galleryRoot.dataset.mkGalleryReady === "true") return;
    if (typeof Flickity === "undefined") return;

    var main = galleryRoot.querySelector("[data-mk-main-slider]");
    if (!main) return;

    var thumbs = galleryRoot.querySelectorAll("[data-mk-thumb]");
    var product = mkParseProductJson();
    var lightboxEnabled =
      galleryRoot.getAttribute("data-lightbox-enabled") === "true";

    var mainSlider = new Flickity(main, {
      cellSelector: "[data-mk-slide]",
      cellAlign: "left",
      contain: true,
      wrapAround: false,
      adaptiveHeight: false,
      pageDots: false,
      prevNextButtons: main.querySelectorAll("[data-mk-slide]").length > 1,
      imagesLoaded: false,
      draggable: main.querySelectorAll("[data-mk-slide]").length > 1
    });

    function setActiveThumb(index, scrollThumb) {
      var thumbButtons = galleryRoot.querySelectorAll("[data-mk-thumb]");

      if (!thumbButtons.length) return;

      thumbButtons.forEach(function(thumb, thumbIndex) {
        var isActive = thumbIndex === index;

        thumb.classList.toggle("is-active", isActive);

        if (isActive) {
          thumb.setAttribute("aria-current", "true");

          if (scrollThumb) {
            var scroller = thumb.closest(".mk-product-gallery__thumbs");

            if (scroller) {
              var thumbLeft = thumb.offsetLeft;
              var thumbWidth = thumb.offsetWidth;
              var scrollLeft = thumbLeft - (scroller.clientWidth / 2) + (thumbWidth / 2);

              scroller.scrollTo({
                left: scrollLeft,
                behavior: "smooth"
              });
            }
          }
        } else {
          thumb.removeAttribute("aria-current");
        }
      });
    }

    function syncToVariantImage() {
      if (!product) return;

      var variantId = mkGetSelectedVariantId();
      var imageId = mkGetVariantImageId(product, variantId);

      if (!imageId) {
        mainSlider.select(0, false, true);
        setActiveThumb(0, true);
        return;
      }

      var index = mkFindSlideIndexByImageId(galleryRoot, imageId);

      mainSlider.select(index, false, true);
      setActiveThumb(index, true);
    }

    function syncVariantToCurrentSlide(index) {
      if (!product) return;

      var slides = galleryRoot.querySelectorAll("[data-mk-slide]");
      if (!slides.length || index < 0 || index >= slides.length) return;

      var imageId = slides[index].getAttribute("data-image-id");
      if (!imageId) return;

      var variant = mkFindVariantByImageId(product, imageId);
      if (!variant) return;

      document.dispatchEvent(new CustomEvent('mk:gallery:variant:select', {
        detail: {
          variant: variant
        }
      }));
    }

    document.addEventListener('mk:variant:change', function(e) {
      if (!mainSlider) return;

      var variant = e.detail.variant;
      if (!variant) return;

      var imageId = null;

      if (variant.featured_image && variant.featured_image.id) {
        imageId = variant.featured_image.id;
      } else if (variant.featured_media && variant.featured_media.id) {
        imageId = variant.featured_media.id;
      }

      if (!imageId) return;

      var index = mkFindSlideIndexByImageId(galleryRoot, imageId);

      mkGalleryChangingFromVariant = true;

      mainSlider.select(index);

      mainSlider.once('settle', function() {
        setActiveThumb(index, true);
        mkGalleryChangingFromVariant = false;
      });

      setTimeout(function() {
        setActiveThumb(index, true);
        mkGalleryChangingFromVariant = false;
      }, 250);
    });

    mainSlider.on("ready", function() {
      setActiveThumb(mainSlider.selectedIndex || 0, false);
    });

    mainSlider.on("change", function(index) {
      setActiveThumb(index, true);

      if (!mkGalleryChangingFromVariant) {
        syncVariantToCurrentSlide(index);
      }
    });

    for (var i = 0; i < thumbs.length; i++) {
      (function(index) {
        thumbs[index].addEventListener("click", function() {
          mainSlider.select(index);
        });
      })(i);
    }

    if (
      lightboxEnabled &&
      typeof PhotoSwipeLightbox !== "undefined" &&
      typeof PhotoSwipe !== "undefined"
    ) {
      var pswpTriggers = galleryRoot.querySelectorAll(
        "[data-mk-lightbox-trigger]"
      );

      for (var p = 0; p < pswpTriggers.length; p++) {
        var trigger = pswpTriggers[p];
        var img = trigger.querySelector("img");
        if (!img) continue;

        trigger.setAttribute("href", img.currentSrc || img.src);
        trigger.setAttribute(
          "data-pswp-width",
          img.getAttribute("width") || "1200"
        );
        trigger.setAttribute(
          "data-pswp-height",
          img.getAttribute("height") || "1200"
        );
      }

      var section = galleryRoot.closest("[data-section-id]");
      if (!section) return;

      var pswpLightbox = new PhotoSwipeLightbox({
        gallery:
          "#MkProductGalleryMain-" + section.getAttribute("data-section-id"),
        children: "[data-mk-lightbox-trigger]",
        pswpModule: PhotoSwipe
      });

      pswpLightbox.on("itemData", function(e) {
        var el = e.itemData.element;
        if (!el) return;

        var img = el.querySelector("img");
        if (!img) return;

        e.itemData.src = el.getAttribute("href") || img.currentSrc || img.src;
        e.itemData.w =
          parseInt(el.getAttribute("data-pswp-width"), 10) ||
          img.naturalWidth ||
          1200;
        e.itemData.h =
          parseInt(el.getAttribute("data-pswp-height"), 10) ||
          img.naturalHeight ||
          1200;
      });

      galleryRoot.addEventListener("click", function(e) {
        var trigger = e.target.closest("[data-mk-lightbox-trigger]");
        if (!trigger) return;

        e.preventDefault();

        var clickedSlide = e.target.closest("[data-mk-slide]");
        var index = 0;

        if (clickedSlide) {
          index =
            parseInt(clickedSlide.getAttribute("data-slide-index"), 10) || 0;
        } else {
          index = mainSlider.selectedIndex || 0;
        }

        pswpLightbox.loadAndOpen(index);
      });
    }

    galleryRoot.dataset.mkGalleryReady = "true";
  }

  function mkInitWhenReady() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", mkInitProductGallery);
    } else {
      mkInitProductGallery();
    }
  }

  mkInitWhenReady();
})();